// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowDownLeftAndArrowUpRight16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-down-left-and-arrow-up-right': IconArrowDownLeftAndArrowUpRight;
    }
}

/**
 * The icon component for the 'arrowDownLeftAndArrowUpRight' icon
 */
export class IconArrowDownLeftAndArrowUpRight extends Icon {
    public constructor() {
        super(arrowDownLeftAndArrowUpRight16X16);
    }
}

registerIcon('icon-arrow-down-left-and-arrow-up-right', IconArrowDownLeftAndArrowUpRight);
export const iconArrowDownLeftAndArrowUpRightTag = 'nimble-icon-arrow-down-left-and-arrow-up-right';
